import { fetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IIndirectTaxFilingV2CalendarParams,
  IIndirectTaxFilingV2CalendarPreviewResponse,
} from './types';

async function fetchIndirectTaxFilingV2CalendarPreview(
  body: IIndirectTaxFilingV2CalendarParams
): Promise<IIndirectTaxFilingV2CalendarPreviewResponse> {
  const response = await fetcher(
    'new-sales-tax/filings-v2/calendar/preview',
    { method: 'POST', body }
  );
  const json = await response.json();
  if (!response.ok) {
    const message =
      typeof json === 'object' && json !== null && 'message' in json
        ? String((json as { message?: unknown }).message ?? '')
        : '';
    throw new Error(message || 'Failed to preview calendar');
  }
  const parsed: IIndirectTaxFilingV2CalendarPreviewResponse = json;
  return parsed;
}

export function useIndirectTaxFilingV2CalendarPreview(
  params: Partial<IIndirectTaxFilingV2CalendarParams> | null
) {
  const body: IIndirectTaxFilingV2CalendarParams | null =
    params &&
    params.corporationId &&
    params.registrationTaxTypeId &&
    params.taxPeriodStartMonth
      ? {
          corporationId: params.corporationId,
          registrationTaxTypeId: params.registrationTaxTypeId,
          filingFrequencies: params.filingFrequencies,
          taxPeriodStartMonth: params.taxPeriodStartMonth,
          taxPeriodEndMonth: params.taxPeriodEndMonth,
        }
      : null;

  const key = body
    ? `new-sales-tax/filings-v2/calendar/preview::${body.corporationId}::${body.registrationTaxTypeId}::${(
        body.filingFrequencies ?? []
      ).join(',')}::${body.taxPeriodStartMonth}::${body.taxPeriodEndMonth ?? ''}`
    : null;

  const { data, error, isLoading, mutate } =
    useSWR<IIndirectTaxFilingV2CalendarPreviewResponse>(
      key,
      async () => {
        if (!body) {
          throw new Error('Calendar preview called without required params');
        }
        return fetchIndirectTaxFilingV2CalendarPreview(body);
      },
      { revalidateOnFocus: false }
    );

  return {
    preview: data?.preview,
    message: data?.message,
    isLoading,
    error,
    mutate,
  };
}
